import { defineComponent as _defineComponent } from 'vue';
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunButton',
    props: {
        id: null,
        full: { type: Boolean },
        title: { default: undefined },
        disabled: { type: Boolean },
        version: { default: undefined },
        force: { type: Boolean },
        variant: { default: "primary" }
    },
    setup(__props) {
        const props = __props;
        const runPath = computed(() => `/workflows/run?id=${props.id}${props.version !== undefined ? `&version=${props.version}` : ""}`);
        function forceRunPath() {
            if (props.force) {
                window.open(runPath.value);
            }
        }
        return { __sfc: true, props, runPath, forceRunPath, faPlay, FontAwesomeIcon, BButton };
    }
});
